/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountTypeCsResponseListBaseResponse as ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse } from '../../models/Models/v3/LoanManagement/account-type-cs-response-list-base-response';

export interface V3LoanManagementAccountTypesGet$Plain$Params {
  id?: string;
  externalPartyId?: string;
  category?: string;
}

export function v3LoanManagementAccountTypesGet$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementAccountTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementAccountTypesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('externalPartyId', params.externalPartyId, {});
    rb.query('category', params.category, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAccountTypeCsResponseListBaseResponse>;
    })
  );
}

v3LoanManagementAccountTypesGet$Plain.PATH = '/v3/loan-management/account-types';
